import { Entities } from './entities';
import { PlanningFixed } from './planningfixed.class';

export class PlanningDay {
    public date: Date;
    public entities: Entities[] = [];
    public fixed: boolean;
    public fixedBy: PlanningFixed;
}
